import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/alert/error.svg';
const AlertErrorSvg = () => React.createElement(IconSvg, null);
export default AlertErrorSvg;
